import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-email-plus.component',
  templateUrl: './icon-email-plus.component.html',
  styleUrl: './icon-email-plus.component.scss',
  standalone: false,

})
export class IconEmailPlusComponent {
  @Input() tooltip?: string;
}
